export default __webpack_public_path__ + "static/media/shopeeIcon.c71c5e81.png";